import React from 'react'
import '../../CSS/Loader/LogoLoader.css'
import logo from '../../Images/Logo.png'

function LogoLoader() {
  return (
    <>
        <img height='100px' className='LogoLoader' src={logo} alt="" />
    </>
  )
}

export default LogoLoader
